import { render, staticRenderFns } from "./DownloadLink.vue?vue&type=template&id=26c1c1b4&scoped=true&"
import script from "./DownloadLink.vue?vue&type=script&lang=js&"
export * from "./DownloadLink.vue?vue&type=script&lang=js&"
import style0 from "./DownloadLink.vue?vue&type=style&index=0&id=26c1c1b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c1c1b4",
  null
  
)

export default component.exports